// eslint-disable-next-line no-restricted-imports
import { SvgIcon, SvgIconProps } from '@mui/material';
import Svg from '@rhg/../public/_n/images/icons/check-with-background.svg';

export const CheckWithBackground = (props: SvgIconProps) => (
    <SvgIcon component={Svg} inheritViewBox {...props} />
);
